"use strict";

import Vue from 'vue';
import axios from "axios";
import {store} from "@/store";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
let config = {
   baseURL: store.getters.apiUrl,
    transformRequest: [function (data:any, headers:any) {
        // Do whatever you want to transform the data
        //console.log("transform",data);
        if(data == null){
            return data;
        }
        if(Object.keys(data).length > 0 && typeof data.sendJson == "undefined"){
            let formdata = new FormData();
            Object.keys(data).forEach((field)=>{
                formdata.append(field,data[field]);
            })
            return formdata;
        }else{
            return data;
        }
    }],
    headers: {
       'X-Requested-With': 'XMLHttpRequest',
        'withCredentials':false,
        "crossDomain":true
    },
};
//headers: {'X-Custom-Header': 'foobar'}
const _axios = axios.create(config);

/*

const instance = axios.create({
  baseURL: 'https://some-domain.com/api/',
  timeout: 1000,
  headers: {'X-Custom-Header': 'foobar'}
});
 */
_axios.interceptors.request.use(
  function(config) {
      // Do something before request is sent
      if(window.localStorage.hasOwnProperty("token")){
          let token = localStorage.getItem("token");
          config.headers['Authorization'] = 'Bearer '+token;
      }else{
          delete config.headers['Authorization'];
      }
      return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
//window.errr  = {};

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
      //console.log("error rejected",error);
      //window.errr = error;
      if(error.response.status == 401){
         store.commit("snackbar",error.response.data.message);
      }
      // Do something with response error
    return Promise.reject(error);
  }
);

export function AxiosPlugin<AxiosPlugOptions>(Vue: any, options?: AxiosPluginOptions): void {
  // do stuff with options
  Vue.prototype.$http = _axios;
}
export class AxiosPluginOptions {
  // add stuff
}
